import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-4xl mx-auto px-3 sm:px-4 py-4 sm:py-6">
        <div className="flex flex-col items-center space-y-4">
          <a 
            href="https://www.linkedin.com/in/benjamin-hofman-22b1b5296/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Calculator className="w-5 h-5 sm:w-6 sm:h-6" />
              <Linkedin className="w-5 h-5 sm:w-6 sm:h-6" />
            </div>
            <span className="text-base sm:text-lg font-medium">Expert comptable Benjamin Hofman</span>
          </a>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-sm sm:text-base">
            <Link
              to="/about"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              À propos
            </Link>
            <Link
              to="/privacy"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/legal"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;